import { TreeSelectDesignTokens } from '@primeuix/themes/types/treeselect';
import componentCommon from '../one-ds-tokens/OneDS-Component-Common.json';
import { tDeep, t } from '../token-utils';

// https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/treeselect/index.ts
const ts = componentCommon.treeselect;
const d = tDeep(ts);

export const TreeselectTelekomDT: TreeSelectDesignTokens = {
  root: {
    background: t(ts.background),
    color: t(ts.color),
    disabledBackground: t(ts.disabled.background),
    disabledColor: t(ts.disabled.color),
    filledBackground: t(ts.filled.background),
    filledHoverBackground: t(ts.filled.hover.background),
    filledFocusBackground: t(ts.filled.focus.background),
    borderColor: t(ts.border.color),
    borderRadius: t(ts.border.radius),
    hoverBorderColor: t(ts.hover.border.color),
    focusBorderColor: t(ts.focus.border.color),
    invalidBorderColor: t(ts.invalid.border.color),
    placeholderColor: t(ts.placeholder.color),
    invalidPlaceholderColor: t(ts.invalid.placeholder.color),
    paddingX: t(ts.padding.x),
    paddingY: t(ts.padding.y),
    focusRing: {
      width: t(ts.focus.ring.width),
      offset: t(ts.focus.ring.offset),
      color: t(ts.focus.ring.color),
    },
    sm: {
      fontSize: t(ts.sm.font.size),
      paddingX: t(ts.sm.padding.x),
      paddingY: t(ts.sm.padding.y),
    },
    lg: {
      fontSize: t(ts.lg.font.size),
      paddingX: t(ts.lg.padding.x),
      paddingY: t(ts.lg.padding.y),
    },
  },
  dropdown: {
    width: t(ts.dropdown.width),
    color: t(ts.dropdown.color),
  },
  overlay: {
    background: t(ts.overlay.background),
    color: t(ts.overlay.color),
    borderColor: t(ts.overlay.border.color),
    borderRadius: t(ts.overlay.border.radius),
  },
  tree: {
    padding: `${d.tree.padding.y} ${d.tree.padding.x}`,
  },
  clearIcon: {
    color: t(ts.clear.icon.color),
  },
  chip: {
    borderRadius: t(ts.chip.border.radius),
  },
};
